import axios from "axios";
import Qs from "qs";
import { createStore } from "redux";
// import { configureStore } from "@reduxjs/toolkit";
import { prod, url, ocpcUrl, localUrl } from "./config";
import MobileDetect from "mobile-detect";
import URI from "urijs";
import _ from "lodash";

const mobileDetect = new MobileDetect(navigator.userAgent);

export const imgPlaceholder = {
  default:
    "data:image/png;base64,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",
};

const reducer = (state = {}, action) => {
  if (action.data) {
    return action.data;
  }
  return state;
};

export const redux = createStore(reducer);

const createAxios = axios.create({ baseURL: url });

createAxios.interceptors.request.use(
  (config) => {
    config.paramsSerializer = (params) =>
      Qs.stringify(params, { arrayFormat: "indices" });

    let url = "";
    url =
      config.url.indexOf("?") === -1 ? config.url : config.url.split("?")[0];
    // console.log("url---------", url);
    if (
      url &&
      (url === "/tgm/is_callback" ||
        url === "/tgm/impute_bind" ||
        url === "/tgm/trigger/warning" ||
        url === "/tgm/get_game")
    ) {
      config.baseURL = ocpcUrl;
    }

    if (
      url &&
      (url === "/get/sts" ||
        url === "/handle/subpackage" ||
        url === "/show/subpackage")
    ) {
      config.baseURL = localUrl;
    }

    if (localStorage.getItem("tgm_uuid")) {
      config.headers["uuid"] = localStorage.getItem("tgm_uuid");
    }

    if (
      localStorage.getItem("deviceToken") &&
      url !== "/get/sts" &&
      url !== "/handle/subpackage" &&
      url !== "/show/subpackage"
    ) {
      config.headers["deviceToken"] = localStorage.getItem("deviceToken");
    }

    config.headers["device-type"] =
      mobileDetect.is("iPhone") ||
      mobileDetect.is("iPad") ||
      navigator.userAgent == "app"
        ? "10"
        : "20";

    config.headers["X-Requested-With"] = "XMLHttpRequest";

    config.headers["brand"] =
      (localStorage.getItem("app") &&
        JSON.parse(localStorage.getItem("app"))?.brand) ||
      "9917";

    config.headers["channel"] = localStorage.getItem("agent") || "x7z1";

    let token = localStorage.getItem("token");
    if (token) {
      config.headers["Token"] = token;
    }
    if (localStorage.getItem("udid")) {
      config.headers["udid"] = localStorage.getItem("udid");
    }
    if (localStorage.getItem("key")) {
      config.headers["key"] = localStorage.getItem("key");
    }
    let user_id = localStorage.getItem("user_id");
    let username = localStorage.getItem("username");
    if (
      (user_id || username) &&
      url !== "/get/sts" &&
      url !== "/handle/subpackage" &&
      url !== "/show/subpackage"
    ) {
      config.headers["member-id"] = user_id;
      config.headers["username"] = username;
      if (config.data instanceof FormData) {
        if (!config.data.get("member_id")) {
          config.data.append("member_id", user_id);
        }
        if (!config.data.get("username")) {
          config.data.append("username", username);
        }
      } else {
        config.data = { username, member_id: user_id, ...config.data };
      }
    }

    if (
      config.url == "/base/apphome/getAppHome" ||
      config.url == "/base/search/index" ||
      config.url == "/base/game/searchAdd" ||
      config.url == "/base/game/getGameDetail" ||
      config.url == "/base/appcategorize/getAppCategorizeData"
    ) {
      config.headers["device"] = "web";
    }

    console.log("config-------------", config);
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

createAxios.interceptors.response.use(
  (res) => {
    // console.log(res);
    // let keys = [];
    // if (res.config?.url?.indexOf('getMyGiftList') > 0) {
    //   keys.push('gift_name');
    // }
    // nameResolveRecursion(res.data, keys);
    if (res?.data?.status?.error_code == 1016) {
      localStorage.removeItem("user_id");
      localStorage.removeItem("username");
      localStorage.removeItem("password");
      localStorage.removeItem("token");
      let url = window.location.hash.substring(1);
      if (url.indexOf("/login") === -1 && url.indexOf("/phonelogin") === -1) {
        general.callback = url;
        general.history.push(
          URI("/login").addQuery("callback", general.callback).toString()
        );
      }
      return Promise.reject(new Error("需要登录"));
    }
    return res;
  },
  (err) => {
    setTimeout(() => {
      try {
        axios.post(`${url}/log`, { log: err, userAgent: navigator.userAgent });
      } catch (e) {}
    }, 222);
  }
);

const general = {
  history: null,
  historys: [],
  location: null,
  game: {},
  goBack(callback) {
    if (
      !(
        window.navigator.standalone ||
        window.location.hostname === "localhost" ||
        window.location.hostname.startsWith("192.168")
      )
    ) {
      general.history.push("/");
      return;
    }
    // console.warn({ callback1: callback, callback2: general.callback });
    if (callback) {
      if (general.callback) {
        let hit;
        // console.log({ callback: general.callback, url });
        general.callbacking = true;
        var si = setInterval(() => {
          let url = window.location.hash.substring(1);
          if (url === general.callback || url === "/") {
            hit = true;
            clearInterval(si);
            general.callbacking = null;
            general.callback = null;
            redux.dispatch({
              type: "type",
              data: { url },
            });
          } else {
            window.history.back();
          }
        }, 10);
        if (!hit) {
          general.history.push(general.callback);
        }
        return;
      }
    }
    general.history.push("/");
  },
  axios: createAxios,
  isLogin() {
    return !!localStorage.getItem("token");
  },
  agent: localStorage.getItem("agent") || "x7z1",
  setAgent() {
    localStorage.setItem("agent", this.agent);
  },
  // || "00008030-000C39E83445402E" || "00008101-00080D42266B001E"
  udid: localStorage.getItem("udid") || "",
  setUdid() {
    localStorage.setItem("udid", this.udid);
  },
  key: localStorage.getItem("key"),
  setKey() {
    localStorage.setItem("key", this.key);
  },
  app: (localStorage.getItem("app") &&
    JSON.parse(localStorage.getItem("app"))) || {
    appname: "9917游戏",
    appicon: "/resources/icon.png",
    applogo: "/resources/account/logo.png",
  },
  setApp() {
    localStorage.setItem("app", JSON.stringify(this.app));
  },
  config: {},
  user: {},
  guide: "",
  guided: localStorage.getItem("guided") || "",
  setGuided() {
    localStorage.setItem("guided", this.guided);
  },
  cloud:
    window.location.hash.substring(1).startsWith("/game/cloud") &&
    navigator.standalone &&
    !document.referrer,
};

if (!prod) {
  let tmp = {
    game_info: {
      game_image: {
        thumb:
          "https://filestorage.9917.cn/attachment/syapp/logo/202112141639473924.jpg!icon_128",
        source:
          "https://filestorage.9917.cn/attachment/syapp/logo/202112141639473924.jpg!icon_128",
      },
      game_ad_image: {
        thumb:
          "https://filestorage.9917.cn/attachment/syapp/lbpic/202201261643179208.jpg!icon_128",
        source:
          "https://filestorage.9917.cn/attachment/syapp/lbpic/202201261643179208.jpg",
      },
      game_name:
        "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
      game_download_num: "124778",
      game_classify_type: "4",
      game_attribute: "",
      game_classify_name: [
        {
          id: "1",
          tagname: "\u5361\u724c",
        },
        {
          id: "53",
          tagname: "Q\u7248",
        },
      ],
      game_url: {
        android_url:
          "http://app-api.bestgame99.com/v3/base/game/download/game_id/103016/app_id/7765/ag/c223",
        ios_url:
          "http://app-api.bestgame99.com/v3/base/game/download/game_id/103016/app_id/7765/ag/c223/type/ios",
        super_ios_url:
          "http://app-api2.9917.cn/v3/base/game/download/game_id/103016/app_id/7765/ag/c223/type/superios",
      },
      game_desc:
        "\u9001\u5341\u8fde\u62bd+\u6d77\u91cf\u70b9\u5238+100\u4e07\u91d1\u5e01",
      game_id: "7765",
      game_group: "772643756",
      game_customernum: "800869917",
      game_group_key:
        "mqqapi://card/show_pslcard?src_type=internal&version=1&uin=772643756&key=ddcbc62e1b7c121f62910f67f7b6743ebc708c1974c9472c2c6dd39f80783e26&card_type=group&source=external",
      game_introduce:
        "\ufeff\u5168\u65b0\u7cbe\u7075\u624b\u6e38\u300a\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145\u300b\u9707\u64bc\u6765\u88ad\uff01\u6bcf\u5929\u9001\u5145\u503c\u5361\uff0c\u767d\u5ad6\u6e38\u620f\u4e0d\u82b1\u94b1\u3002\u4e0a\u7ebfVIP8\uff0c\u66f4\u6709\u767e\u62bd\u8c6a\u793c\u7b49\u4f60\u6765\u62ff\u3002\u8d85\u503c\u57fa\u91d120\u500d\u8fd4\u5229\uff0c\u5173\u5361\u57fa\u91d135\u500d\u8fd4\u5229\uff0c\u7edd\u7248\u8c6a\u534e\u5927\u793c\u5305\uff0c8\u5929\u767b\u5f55\u9001\u8d85\u4eba\u6c14\u5f3a\u529b\u7cbe\u7075\u70c8\u7130\u66b4\u9f99\uff0c\u5e26\u9886\u4f60\u8f7b\u677e\u63a8\u56fe\u6253boss\u3002\u66f4\u6709\u5b9a\u5236\u7cbe\u7075\u73a9\u6cd5\uff0c\u60f3\u600e\u4e48\u57f9\u517b\u5c31\u600e\u4e48\u57f9\u517b\u3002\u6253\u9020\u5c5e\u4e8e\u4f60\u81ea\u5df1\u7684\u6700\u5f3a\u9635\u5bb9\u4f53\u9a8c\uff0c\u6210\u4e3a\u7cbe\u7075\u738b\u4e0d\u518d\u662f\u68a6\u60f3\u3002",
      game_ur_list: [
        "https://filestorage.9917.cn/attachment/syapp/images/2112/16394739241.jpg!gameDetail",
        "https://filestorage.9917.cn/attachment/syapp/images/2112/16394739252.jpg!gameDetail",
        "https://filestorage.9917.cn/attachment/syapp/images/2112/16394739253.jpg!gameDetail",
        "https://filestorage.9917.cn/attachment/syapp/images/2112/16394739254.jpg!gameDetail",
        "https://filestorage.9917.cn/attachment/syapp/images/2112/16394739255.jpg!gameDetail",
      ],
      game_feature_list: [
        {
          title: "\u798f\u5229",
          content:
            "\ufeff\u5145\u503c\u6bd4\u4f8b1:500\r\n\r\n\u2605\u4e0a\u7ebf\u9001188888\u70b9\u5238\u3001100\u4e07\u91d1\u5e01\u3002\r\n\r\n\u2605\u767b\u5f55\u5148\u9001\u5341\u8fde\u62bd\uff0c\u8fde\u767b7\u65e5\u518d\u9886\u4e00\u767e\u62bd\u3002\r\n\r\n\u26058\u5929\u767b\u5f55\uff0c\u5929\u5929\u62ff\u9ad8\u989d\u5956\u52b1\uff0c\u7b2c8\u5929\u9001\u795e\u5ba05\u661f\u70c8\u7130\u66b4\u9f99\u3002\r\n\r\n\u2605\u5b8c\u6210\u65e5\u5e38\u4efb\u52a1\u9886\u5145\u503c\u5361\uff0c\u4e3b\u7ebf\u4efb\u52a1\u5956\u52b1\u6d77\u91cf\u70b9\u5238\u3002\r\n\r\n\u2605\u8d85\u503c\u57fa\u91d120\u500d\u8fd4\u5229\uff0c\u72c2\u9001\u4ef7\u503c\u767e\u4e07\u70b9\u5238\u5f3a\u529b\u9053\u5177\u3002\r\n\r\n\u2605\u540e\u7f00\u8bf4\u660e\uff1a\u6e38\u620f\u91cc\u5b8c\u6210\u6bcf\u65e5\u65e5\u5e38\u4efb\u52a1\u9001\u5145\u503c\u5361\u3002",
        },
        {
          title: "\u8fd4\u5229",
          content:
            "\ufeff\u5355\u65e5\u7d2f\u8ba1\u5145\u503c\u8fd4\u5229\uff08\u624b\u52a8\u8fd4\u5229\u9700\u7533\u8bf7\uff09\r\n\r\n\u2605\u5145\u503c100-499\u5143\u8fd410%\r\n\r\n\u2605\u5145\u503c500-999\u5143\u8fd430%\r\n\r\n\u2605\u5145\u503c1000-2999\u5143\u8fd450%\r\n\r\n\u2605\u5145\u503c3000-4999\u5143\u8fd4100%\r\n\r\n\u2605\u5145\u503c5000-9999\u5143\u8fd4150%\r\n\r\n\u2605\u5145\u503c10000-19999\u8fd4\u5229200%\r\n\r\n\u2605\u5145\u503c2\u4e07\u53ca\u4ee5\u4e0a\u8fd4\u5229300%\r\n\r\n\u8fd4\u5229\u4ec5\u9650\u5355\u65e5\u7d2f\u8ba1\u5145\u503c\uff0c\u6bcf\u65e524\u70b9\u6e05\u96f6\uff0c\u7b2c\u4e8c\u5929\u91cd\u65b0\u8ba1\u7b97\u7d2f\u8ba1\uff1a\r\n\r\n\u8fd4\u5229\u53d1\u653e\u65b9\u5f0f\uff1a\u90ae\u4ef6\u53d1\u653e\r\n\r\n\u8fd4\u5229\u53d1\u653e\u65f6\u95f4\uff1a\u7533\u8bf7\u8fd4\u5229\u540e1-2\u4e2a\u5de5\u4f5c\u65e5\u5185\r\n\r\n\u8fd4\u5229\u7533\u8bf7\u662f\u5426\u9700\u8981\u89d2\u8272id\uff1a\u662f\r\n\r\n\u8fd4\u5229\u8d27\u5e01\uff1a\u70b9\u5238\r\n\r\n\u6708\u5361\u662f\u5426\u7b97VIP\u7ecf\u9a8c\uff1a\u662f\r\n\r\n\u6708\u5361\u662f\u5426\u7b97\u9996\u5145\uff1a\u5426\r\n\r\n\u6e38\u620f\u5185\u8d60\u9001\u7684\u5145\u503c\u5361\u662f\u5426\u8ba1\u5165\u8fd4\u5229\uff1a\u5426\r\n\r\n\u5145\u503c\u6708\u5361\u3001\u7ec8\u8eab\u5361\u3001\u793c\u5305\u3001\u57fa\u91d1\u7b49\u662f\u5426\u8ba1\u5165\u8fd4\u5229\uff1a\u662f\r\n\r\n\u6e29\u99a8\u63d0\u793a\uff1a\r\n\r\n1\u3001\u8fd4\u5229\u7684\u8d27\u5e01\u662f\u6e38\u620f\u5185\u7684\u975e\u7ed1\u5b9a\u8d27\u5e01\u6216\u8005\u7ed1\u5b9a\u8d27\u5e01(\u5143\u5b9d/\u94bb\u77f3/\u6c34\u7389\u7b49\u7b49)\u3002\r\n\r\n2\u3001\u5355\u65e5\u7d2f\u8ba1\u5145\u503c\u8fbe\u5bf9\u5e94\u6863\u4f4d\u53ef\u53c2\u4e0e\u8fd4\u5229\uff0c\u53ea\u9650\u7d2f\u8ba1\u5355\u65e5\uff0c\u6b21\u65e5\u91cd\u65b0\u8ba1\u7b97\u3002\r\n\r\n3\u3001\u8fd4\u5229\u4f1a\u572848\u5c0f\u65f6\u5185\u53d1\u653e\u5230\u6e38\u620f\u89d2\u8272\u5185\uff0c\u5982\u9047\u8282\u5047\u65e5\u53ef\u80fd\u51fa\u73b0\u5ef6\u8bef\u7684\u60c5\u51b5\u3002\r\n\r\n4\u3001\u8fd4\u5229\u6709\u3010\u6b21\u65e5\u81ea\u52a8\u53d1\u653e\u3011\u3010\u5373\u65f6\u81ea\u52a8\u53d1\u653e\u3011\u3010\u8054\u7cfb\u5ba2\u670d\u7533\u8bf7\u3011\u4e09\u79cd\u6a21\u5f0f\uff0c\u8bf7\u7559\u610f\u201c\u6e38\u620f\u7279\u8272\u201d\u5185\u7684\u6807\u6ce8\u4fe1\u606f\u3002\r\n\r\n------------------\r\n\r\n\u8fd4\u5229\u8ba1\u7b97\u516c\u5f0f\uff1a\r\n\r\n\u8fd4\u5229\u8d27\u5e01\u6570 = \u5145\u503c\u91d1\u989d x \u57fa\u7840\u5145\u503c\u6bd4\u4f8b x \u5bf9\u5e94\u5145\u503c\u6863\u4f4d\u7684\u767e\u5206\u6bd4",
        },
        {
          title: "VIP\u8868",
          content:
            '<!doctype html>\n<html lang="en">\n<head>\n    <meta charset="UTF-8">\n    <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">\n    <meta http-equiv="X-UA-Compatible" content="ie=edge">\n    <title>vip\u4ef7\u683c\u8868</title>\n    <style>\n        body{\n            max-width: 640px;\n            margin: 0 auto;\n            padding: 1em;\n        }\n        table{\n            width: 100%;\n            margin: 0;\n            padding: 0;\n            border-collapse: collapse;\n            border-spacing: 0;\n        }\n        tr{\n            margin: 0;\n            padding: 0;\n        }\n        td{\n            padding: .5em;\n            font-size: 12px;\n            text-align: center;\n            line-height: 1.35;\n            border: 1px solid #ccc;\n        }\n        .empty{\n            font-size: 16px;\n            position: absolute;\n            top: 50%;\n            left: 0;\n            right: 0;\n            text-align: center;\n            transform: translateX(-50%);\n        }\n    </style>\n</head>\n<body>\n<table>\n                    <tr>\n                                    <td  >VIP\u7b49\u7ea7</td>\n                                    <td  >\u6240\u9700RMB</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP9</td>\n                                    <td  >30\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP10</td>\n                                    <td  >100\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP11</td>\n                                    <td  >300\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP12</td>\n                                    <td  >600\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP13</td>\n                                    <td  >1000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP14</td>\n                                    <td  >1500\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP15</td>\n                                    <td  >2000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP16</td>\n                                    <td  >2500\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP17</td>\n                                    <td  >3000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP18</td>\n                                    <td  >5000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP19</td>\n                                    <td  >7000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td  >VIP20</td>\n                                    <td  >10000\u5143</td>\n                            </tr>\n                    <tr>\n                                    <td colspan="2" >ps\uff1a\u4fe1\u606f\u7531\u53d1\u884c\u5546\u63d0\u4f9b\uff0c\u4ec5\u4f9b\u53c2\u8003\uff0c\u5982\u4e0e\u5b9e\u9645\u4e0d\u7b26\uff0c\u8bf7\u73a9\u5bb6\u4ee5\u6e38\u620f\u5185\u5b9e\u9645\u60c5\u51b5\u4e3a\u51c6\uff01</td>\n                            </tr>\n            </table>\n</body>\n</html>',
        },
      ],
      game_activity: [
        {
          title:
            "\uff088.1-8.7\u5341\u500d\uff09\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
          dateline: "1659078942",
          newid: "107665",
          deadline: "1659888000",
          status: 1,
        },
        {
          title:
            "\uff087.9-8.31\uff09\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
          dateline: "1657269945",
          newid: "105985",
          deadline: "1661961600",
          status: 1,
        },
        {
          title:
            "\u3010\u6c38\u4e45\u3011\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145\u7ebf\u4e0b\u6d3b\u52a8",
          dateline: "1639474167",
          newid: "89149",
          deadline: "1",
          status: 1,
        },
      ],
      kaifu_info: [
        {
          kaifuid: "907033",
          kaifuname: "836\u533a",
          starttime: "1659592800",
        },
        {
          kaifuid: "907034",
          kaifuname: "837\u533a",
          starttime: "1659628800",
        },
        {
          kaifuid: "907035",
          kaifuname: "838\u533a",
          starttime: "1659679200",
        },
        {
          kaifuid: "907036",
          kaifuname: "839\u533a",
          starttime: "1659715200",
        },
        {
          kaifuid: "907037",
          kaifuname: "840\u533a",
          starttime: "1659765600",
        },
        {
          kaifuid: "907038",
          kaifuname: "841\u533a",
          starttime: "1659801600",
        },
        {
          kaifuid: "907039",
          kaifuname: "842\u533a",
          starttime: "1659852000",
        },
        {
          kaifuid: "907040",
          kaifuname: "843\u533a",
          starttime: "1659888000",
        },
        {
          kaifuid: "907041",
          kaifuname: "844\u533a",
          starttime: "1659938400",
        },
        {
          kaifuid: "907042",
          kaifuname: "845\u533a",
          starttime: "1659974400",
        },
      ],
      gift_bag_list: [
        {
          packname: "\u4e03\u5915\u793c\u5305",
          packcontent:
            "\u91d1\u5e01*77777\uff0c\u70b9\u5238*77777\uff0c\u8fdb\u9636\u77f3*77\t\t\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "44094",
          starttime: "1659542400",
          endtime: "1659887999",
          surplus_num: "0",
          packcount: "30",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u7aef\u5348\u793c\u5305",
          packcontent:
            "\u70b9\u5238*5000\u3001\u7cbe\u7075\u53ec\u5524\u5377*10\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "42110",
          starttime: "1653991911",
          endtime: "1685614310",
          surplus_num: "0",
          packcount: "1882",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u6625\u8282\u793c\u5305",
          packcontent:
            "\u70b9\u5238*5000\t\u8fdb\u9636\u77f3*50\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "37924",
          starttime: "1643166124",
          endtime: "1674788523",
          surplus_num: "0",
          packcount: "3207",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u5143\u65e6\u793c\u5305",
          packcontent:
            "\u70b9\u5238*2022\uff0c\u91d1\u7816*2\t\t(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "36558",
          starttime: "1640327483",
          endtime: "1671949882",
          surplus_num: "0",
          packcount: "2907",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u5723\u8bde\u793c\u5305",
          packcontent:
            "\u70b9\u5238*1225\uff0c\u8fdb\u9636\u77f3*100\t\t\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "36557",
          starttime: "1640327446",
          endtime: "1671949845",
          surplus_num: "0",
          packcount: "2668",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u5ef6\u671f\u793c\u5305",
          packcontent:
            "\u70b9\u5238*2500\t\u666e\u901a\u8fdb\u5316\u77f3*100\t\u91d1\u5e01*55555\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "35992",
          starttime: "1639472400",
          endtime: "1671094800",
          surplus_num: "0",
          packcount: "2790",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u72ec\u5bb6\u793c\u5305",
          packcontent:
            "\u70b9\u5238*1500\t\u666e\u901a\u8fdb\u5316\u77f3*20\t\u91d1\u5e01*88888\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "35991",
          starttime: "1639472400",
          endtime: "1671094800",
          surplus_num: "0",
          packcount: "2676",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u9884\u7ea6\u793c\u5305",
          packcontent:
            "\u70b9\u5238*1000\t\u7fbd\u6bdb*10\t\u91d1\u5e01*77777\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "35990",
          starttime: "1639472400",
          endtime: "1671094800",
          surplus_num: "0",
          packcount: "2664",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
        {
          packname: "\u65b0\u624b\u793c\u5305",
          packcontent:
            "\u70b9\u5238*1000\t\u8fdb\u9636\u77f3*20\t\u91d1\u5e01*66666\r\n(\u6bcf\u4e2a\u8d26\u53f7\u9650\u9886\u4e00\u6b21)",
          packid: "35989",
          starttime: "1639472400",
          endtime: "1671094800",
          surplus_num: "0",
          packcount: "2746",
          unicode: "1",
          gift_type: "1",
          recharge_amount: "0.00",
          conform_visible: "0",
          is_vip: "1",
        },
      ],
      downButton: {
        Super: 1,
        Normal: 0,
      },
      isCanDownSuper: 1,
      game_size: {
        android_size: "3.93 MB",
        ios_size: "23.02 MB",
      },
      cloud_is_double: "",
      is_support_android: "",
      is_support_ios: "",
      pkg: "com.yqw.cjjlq.bt.yx9917",
      package_name: "",
      maiyou_gameid: "103016",
      game_species_type: "1",
      discount: "1.00",
      screen_orientation: "1",
      introduction: "",
      video_url:
        "https://filestorage.9917.cn/attachment/video/20211214172525.mp4",
      video_source_url:
        "https://filestorage.9917.cn/attachment/video/20211214172525.mp4",
      video_img_url:
        "https://filestorage.9917.cn/attachment/video/20211214172525.mp4?x-oss-process=video/snapshot,t_200,w_800",
      starting_time: "1639706400",
      played_count: "15506",
      question_count: "2",
      answer_count: "0",
      cp_game_id: "",
      cp_channel_id: "",
      is_collected: 0,
      is_reserved: 0,
      reserved_type: null,
      reserved_total: 193,
      allow_download: 1,
      voucher: "11",
      valid_voucher: "11",
      received_voucher: 0,
      url: "",
      status: "1",
      banner_url:
        "https://filestorage.9917.cn/attachment/syapp/banner/202201261643179208.jpg",
      allow_rebate: 1,
    },
    recommend_info: [
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202203091646809721.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202203091646809721.jpg",
        },
        game_name: "\u4e09\u56fdonline-\u9001VIP\u7ea2\u5305",
        game_id: "8081",
        game_species_type: "1",
      },
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202203171647488568.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202203171647488568.jpg",
        },
        game_name: "\u5343\u79cb\u8f9e-GM\u79d1\u6280\u5237\u5145",
        game_id: "8205",
        game_species_type: "1",
      },
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202207281659002932.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202207281659002932.jpg",
        },
        game_name: "\u738b\u8005\u5149\u8f89-\u6302\u673a\u65e0\u9650\u62bd",
        game_id: "8830",
        game_species_type: "1",
      },
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202205091652063181.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202205091652063181.jpg",
        },
        game_name: "\u5192\u9669\u738b2-\u5b98\u6302\u514d\u5145\u7248",
        game_id: "8350",
        game_species_type: "1",
      },
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202108131628843681.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202108131628843681.jpg",
        },
        game_name: "\u6c34\u6d52\u4e71\u6597-\u9001\u9876\u7ea7\u795e\u5c06",
        game_id: "7052",
        game_species_type: "1",
      },
      {
        game_image: {
          thumb:
            "https://filestorage.9917.cn/attachment/syapp/logo/202110211634806041.jpg",
          source:
            "https://filestorage.9917.cn/attachment/syapp/logo/202110211634806041.jpg",
        },
        game_name:
          "\u5929\u7a7a\u7684\u9b54\u5e7b\u57ce-GM\u8d44\u6e90\u5168\u514d",
        game_id: "7454",
        game_species_type: "1",
      },
    ],
    comment_topic_id: "103016",
    down_type: 1,
    vip_ios_url: "",
    voucherslist: [
      {
        id: "235359",
        name: "\u4ee3\u91d1\u5238",
        amount: "6.00",
        meet_amount: "12.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9858",
        received_total: "142",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235360",
        name: "\u4ee3\u91d1\u5238",
        amount: "15.00",
        meet_amount: "30.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9929",
        received_total: "71",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235361",
        name: "\u4ee3\u91d1\u5238",
        amount: "25.00",
        meet_amount: "50.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9959",
        received_total: "41",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235362",
        name: "\u4ee3\u91d1\u5238",
        amount: "49.00",
        meet_amount: "98.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9944",
        received_total: "56",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235363",
        name: "\u4ee3\u91d1\u5238",
        amount: "64.00",
        meet_amount: "128.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9950",
        received_total: "50",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235364",
        name: "\u4ee3\u91d1\u5238",
        amount: "164.00",
        meet_amount: "328.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9965",
        received_total: "35",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235365",
        name: "\u4ee3\u91d1\u5238",
        amount: "324.00",
        meet_amount: "648.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9934",
        received_total: "66",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235366",
        name: "\u4ee3\u91d1\u5238",
        amount: "500.00",
        meet_amount: "1000.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9975",
        received_total: "25",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235367",
        name: "\u4ee3\u91d1\u5238",
        amount: "1000.00",
        meet_amount: "2000.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9977",
        received_total: "23",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235368",
        name: "\u4ee3\u91d1\u5238",
        amount: "1500.00",
        meet_amount: "3000.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9975",
        received_total: "25",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
      {
        id: "235369",
        name: "\u4ee3\u91d1\u5238",
        amount: "2500.00",
        meet_amount: "5000.00",
        start_time: "1659283200",
        end_time: "1661961599",
        use_type: "deduct",
        game_id: "103016",
        game_name:
          "\u8d85\u7ea7\u7cbe\u7075\u7403-\u65e0\u9650\u9001\u771f\u5145",
        game_types: "BT\u6e38\u620f",
        total: "10000",
        surplus_total: "9971",
        received_total: "29",
        start_date: "2022-08-01 00:00:00",
        end_date: "2022-08-31 23:59:59",
        is_received: "0",
      },
    ],
    voucher_info: {
      amount: 6147,
      num: 11,
    },
    game_comment_num: "194",
    game_trade_num: "1",
  };
  general.game = { ...tmp, ...tmp.game_info };
}

export const spm = (spm) => general.axios.post("/spm", { spm });

export const nameResolve = (name) => {
  return name?.split("-") || [];
};

export const nameResolveRecursion = (data, keys = []) => {
  if (_.isObject(data)) {
    for (const key in data) {
      if (_.isObject(data[key]) || _.isArray(data[key])) {
        nameResolveRecursion(data[key], keys);
      } else if (["game_name", ...keys].includes(key)) {
        let res = nameResolve(data[key]);
        data[key + "_main"] = res[0];
        data[key + "_branch"] = res[1];
      }
    }
  } else if (_.isArray(data)) {
    for (const val of data) {
      if (_.isObject(val) || _.isArray(val)) {
        nameResolveRecursion(val, keys);
      }
    }
  }
};

export default general;
